const freeEmailProviders = [
    "gmail.com", "googlemail.com",
    "yahoo.com", "ymail.com", "rocketmail.com",
    "outlook.com", "hotmail.com", "live.com", "msn.com",
    "icloud.com", "me.com", "mac.com",
    "qq.com", "163.com", "126.com",       // major China free providers
    "mail.ru", "rambler.ru", "yandex.com",
    "gmx.com", "gmx.net", "web.de",      // Europe
    "t-online.de", "freenet.de",
    "mail.com", "inbox.com", "protonmail.com", "proton.me",
    "aol.com", "att.net", "bellsouth.net",
    "sbcglobal.net", "verizon.net", "comcast.net", "cox.net",
    "earthlink.net", "juno.com", "charter.net",
    "hotmail.co.uk", "hotmail.fr", "hotmail.de",
    "yahoo.co.uk", "yahoo.ca", "yahoo.com.au", "yahoo.co.jp",
    "yahoo.co.id", "yahoo.com.sg",
    "zoho.com", "fastmail.com", "tutanota.com",
    "mailfence.com", "safe-mail.net", "hushmail.com",
    "iname.com", "lavabit.com", "pobox.com",
    "1mail.net", "1freeemail.com", "email.com",
    "bigstring.com", "games.com", "love.com",
    "wow.com", "ygm.com",  // older AOL-acquired legacy domains
    "optonline.net", "ntlworld.com", "shaw.ca",
    "optusnet.com.au", "telenet.be", "planet.nl",
    "aliceadsl.fr", "club-internet.fr", "voila.fr",
    "blueyonder.co.uk", "sky.com",
    "zonnet.nl",
    "tin.it", "live.it", "arcor.de", "hetnet.nl"
];

export const isWorkEmail = (email: string): 'Invalid_Email' | 'Free_Email' | 'Work_Email' => {
    // Basic email format check
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!emailRegex.test(email)) return 'Invalid_Email';

    // Extract domain
    const domain = email.split("@")[1].toLowerCase();

    // Reject free providers
    return freeEmailProviders.includes(domain)
        ? 'Free_Email'
        : 'Work_Email'
        ;
}

export const hasWhitespace = (value: string) => {
    return /\s/.test(value)
}


export type IPasswordIncludes  = 'uppercaseAndLowercase' | 'number' | 'specialChar' | 'maxLength'

export const validatePassword = (value: string) => {

    let passwordIncludes = [];

    // At least one uppercase & lowercase char
    if ((/[A-Z]/.test(value)) && (/[a-z]/.test(value))) {
        passwordIncludes.push('uppercaseAndLowercase');
    }

    // At least one number used
    if (/\d/.test(value)) {
        passwordIncludes.push('number');
    }

    // At least ene special char
    if (/[^A-Za-z0-9]+/.test(value)) {
        passwordIncludes.push('specialChar');
    }

    // Minimum 8 characters
    if (value.length > 8) {
        passwordIncludes.push('maxLength')
    }

    return {
        passwordIsValid: passwordIncludes.length === 4,
        passwordIncludes
    }
}